module.exports = __webpack_public_path__ + "static/media/sinwave.ae8fb780.jpg";